// js-sidebar がサイドバーとして js-main-content に追従する
document.addEventListener('DOMContentLoaded', function() {
  const sidebar = document.querySelector('.js-sidebar-sticky');
  const mainContent = document.querySelector('.js-sidebar-sticky-container');
  const PC_WIDTH = 1180; // PC判定の閾値（必要に応じて調整）

  if (sidebar && mainContent) {
    let ticking = false;
    let lastScrollY = window.scrollY;
    const headerHeight = document.querySelector('.l-header').offsetHeight + 20; // ヘッダーの高さに応じて調整

    // 初期幅を保存
    const initialWidth = sidebar.offsetWidth;

    // サイドバーの位置を更新
    function updateSidebar() {
      if (window.innerWidth > PC_WIDTH) {
        const mainRect = mainContent.getBoundingClientRect();
        const sidebarRect = sidebar.getBoundingClientRect();
        const mainBottom = mainRect.bottom;
        const sidebarHeight = sidebarRect.height;
        const mainHeight = mainContent.scrollHeight;

        // 幅を初期値に固定
        sidebar.style.width = `${initialWidth}px`;
        sidebar.classList.remove('is-mobile');

        // メインコンテンツの表示範囲内でのみ追従
        if (mainHeight <= 520) {
          sidebar.style.position = 'static';
          sidebar.style.top = '0';
        }
        else if (mainRect.top <= headerHeight && mainBottom > sidebarHeight + headerHeight) {
          sidebar.style.position = 'fixed';
          sidebar.style.top = `${headerHeight}px`;
        }
        // メインコンテンツの下端に到達
        else if (mainBottom <= sidebarHeight + headerHeight) {
          sidebar.style.position = 'absolute';
          sidebar.style.top = `${mainRect.height - sidebarHeight}px`;
        }
        // 初期位置
        else {
          sidebar.style.position = 'static';
          sidebar.style.top = '0';
        }
      } else {
        // モバイル時はリセット
        sidebar.style.position = 'static';
        sidebar.style.top = '0';
        sidebar.style.width = '100%';
        sidebar.classList.add('is-mobile');
      }

      ticking = false;
    }

    // スクロールイベントの最適化
    function onScroll() {
      lastScrollY = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateSidebar();
          ticking = false;
        });
        ticking = true;
      }
    }

    // リサイズイベントの処理
    function onResize() {
      if (window.innerWidth > PC_WIDTH) {
        // PC時は初期幅を維持
        sidebar.style.width = `${initialWidth}px`;
      } else {
        // モバイル時は幅をリセット
        sidebar.style.width = '100%';
      }
      updateSidebar();
    }

    // イベントリスナーの設定
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    // 初期化
    updateSidebar();
  }
});

// サイドバーのインデックスをクリックしたら、そのセクションにスクロール
document.addEventListener('DOMContentLoaded', function() {
  const SP_WIDTH = 768;
  const sections = $('[id^="team-"]');
  const sideIndexItems = $('.js-sidebar-click a');
  const sideIndex = $('.js-sidebar-click');

  // サイドインデックスの位置に基づいてアクティブアイテムを設定
  const handleScroll = function() {
    const scrollBottom = $('.js-sidebar-sticky').offset().top + $('.js-sidebar-sticky').height(); // 画面最下部の位置
    const documentHeight = $('.js-sidebar-sticky-container').offset().top + $('.js-sidebar-sticky-container').height(); // ドキュメント全体の高さ

    sections.each(function(index) {
      const currentSection = $(this);
      const nextSection = sections.eq(index + 1);
      const sectionTop = currentSection.offset().top;
      const sideIndexPosition = sideIndex.offset()?.top + 1 || 0;

      if (nextSection.length) {
        // 次のセクションがある場合
        const nextSectionTop = nextSection.offset().top;
        if (sideIndexPosition >= sectionTop && sideIndexPosition < nextSectionTop) {
          sideIndexItems.removeClass('is-active');
          sideIndexItems.eq(index).addClass('is-active');
        }
      } else {
        // 最後のセクションの場合
        if (sideIndexPosition >= sectionTop || scrollBottom >= documentHeight - 10) {
          sideIndexItems.removeClass('is-active');
          sideIndexItems.eq(index).addClass('is-active');
        }
      }
    });
  };

  if (sections.length > 0 && window.innerWidth > SP_WIDTH) {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
  }
});
